import { newConfig } from '@bizfly/shared';
import store from '@/store';

export async function getNewEndpoint() {
  const config = await newConfig();
  const BACKEND_URL = `${config?.services?.iam?.backendUrl}/v2`;

  const URL = {
    SSO_URL: config?.base?.ssoUrl,
    INTRO: 'https://docs.bizflycloud.vn/iam',
    USER_MANUAL: 'https://docs.bizflycloud.vn/iam/quickstart',
    PROBLEM: 'https://docs.bizflycloud.vn/iam/resources/question_and_answer',
    PROJECT: 'https://docs.bizflycloud.vn/iam/quickstart',
    INTEGRATED: 'https://docs.bizflycloud.vn/iam/howtos/integration_iam_cloudserver',
    ROLE: 'https://docs.bizflycloud.vn/iam/howtos/custom_role',
  };

  store.dispatch('urlIAM/updateURL', URL);

  return {
    BACKEND_URL,
    USERS: `${BACKEND_URL}/users`,
    SERVICES: `${BACKEND_URL}/services`,
    PROJECTS: `${BACKEND_URL}/projects`,
    ROLES: `${BACKEND_URL}/roles`,
    RESOURCES: `${BACKEND_URL}/resources`,
    ALL: `${BACKEND_URL}/all`,
    CONDITIONS: `${BACKEND_URL}/conditions`,
    LOGS: `${BACKEND_URL}/logs`,
    COUNTDOWN: `${BACKEND_URL}/countdown `,
    EXPORT: `${BACKEND_URL}/export`,
    TAGS: `${BACKEND_URL}/tags`,
  };
}
